import React from "react";

const SRC = "/logo-vectra.png";
const RATIO = 1380 / 353;

/**
 * VECTRA brand lockup.
 * - light contexts: logo rendered directly (asset has a white plate)
 * - dark contexts: logo placed on a white rounded chip so the navy wordmark stays legible
 */
export const Logo = ({ size = 36, dark = false, tagline = false, className = "" }) => {
  const height = Math.round(size * 1.05);
  const img = (
    <img
      src={SRC}
      alt="VECTRA — AI Meeting Intelligence Platform"
      width={Math.round(height * RATIO)}
      height={height}
      style={{ height, width: "auto" }}
      className="block select-none"
      draggable="false"
    />
  );

  return (
    <div className={`inline-flex flex-col items-start ${className}`} data-testid="vectra-logo">
      {dark ? (
        <span className="inline-flex items-center rounded-xl bg-white px-3.5 py-2 shadow-[0_6px_24px_rgba(2,8,32,0.35)]">
          {img}
        </span>
      ) : (
        img
      )}
      {tagline && (
        <span className={`mt-2.5 text-[9px] tracking-[0.3em] font-semibold ${dark ? "text-slate-300" : "text-slate-500"}`}>
          INTELLIGENCE · PRODUCTIVITY · INNOVATION
        </span>
      )}
    </div>
  );
};

/** Compact square mark, for avatars / favicons / tight spaces. */
export const LogoMark = ({ size = 32 }) => (
  <span
    className="grid shrink-0 place-items-center overflow-hidden rounded-xl bg-white"
    style={{ height: size, width: size }}
    data-testid="vectra-logo-mark"
  >
    <img
      src={SRC}
      alt="VECTRA"
      style={{ height: size * 0.92, width: "auto", objectFit: "cover", objectPosition: "left center", maxWidth: size }}
      className="block select-none"
      draggable="false"
    />
  </span>
);
